/**
 * Capitalizes first letters of words in string.
 * @param {string} str String to be modified
 * @param {boolean=false} lower Whether all other letters should be lowercased
 * @return {string}
 * @usage
 *   capitalize('fix this string');     // -> 'Fix This String'
 *   capitalize('javaSCrIPT');          // -> 'JavaSCrIPT'
 *   capitalize('javaSCrIPT', true);    // -> 'Javascript'
 */
export const capitalize = (str) => {
  const lower = str.toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
};

export const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
});

export const formatNumber = (number) => {
  return formatter.format(number);
};

export const formatNumberDecimal = (number) => {
  return new Intl.NumberFormat("en-us", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(number);
};

/**
 *
 * @param {string} prefix
 * @returns {string}
 */
export const generateUniqueId = (prefix = "") => {
  const array = new Uint32Array(8);
  crypto.getRandomValues(array);
  let uniqueId = "";
  for (let i = 0; i < array.length; i++) {
    uniqueId += array[i].toString(16).padStart(8, "0");
  }
  const timestamp = Date.now().toString(16).padStart(12, "0");
  return prefix + timestamp + uniqueId;
};
